import PropTypes from "prop-types";
import React, { useState } from "react";
import { Col, Row, Container } from 'react-bootstrap';
import { Link } from "@StarberryUtils";
import "./TeamBlock.scss";
import DotsImg from "../../../images/dots-img.svg"
import DownloadPDF from "../../DownloadPDF/DownloadPDF";
import ReactMarkdown from "react-markdown"
import { getSrc } from "gatsby-plugin-image"

// import { motion } from "framer-motion";
// import { InView } from "react-intersection-observer";

const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.4,
      ease: [0.33, 1, 0.68, 1],
      duration: 0.4
    }
  }
}

const titleVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 1
    }
  }
}

const contentVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    delay: 0.4,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 1
    }
  }
}


const TeamBlock = (props) => {
  const [openDownloadForm, setOpenDownloadForm] = useState(false);

  return (
    <>
      <section className="managing-sec  team-block">
        <Container>
          <Row>
            <Col lg={props.People ? 8 : 12} >
              <div variants={titleVariants} className="content-wrap">
                {props.Title ? <h2>{props.Title}</h2> : ''}
                {props.Content ? <ReactMarkdown source={props.Content} allowDangerousHtml className="editor" /> : ''}
                {
                  props.CTA_Label && props.CTA_Link.includes('download_') ?
                    <button className="btn"
                      onClick={() => {
                        setOpenDownloadForm(true)
                      }}
                    >Download PDF</button> :
                    props.CTA_Label && props.CTA_Link ?
                      <Link to={`${props.CTA_Link}`} class="btn">{props.CTA_Label}</Link>
                      : ""
                }
              </div>

            </Col>
            {props.People &&
              <Col lg={4} /**className="textContact animate__animated"*/ >
                <div className="team d-none d-lg-block">
                  {props.People ?
                    <>
                      <div className="user-profile ">
                        {props.People.Signature_Image ?
                          <div className="team-image "><img loading="lazy" className="" src={props.People.Signature_Image.publicURL} alt={`${props.People.Name} Signature - Martyn Gerrard`} /></div> : ''}
                        <div className="team-info">
                          <div className="name"><strong >{props.People.Name}  </strong>{props?.People?.Membership}  </div>
                          <span className="destination">{props.People.Designation}</span>
                        </div>
                      </div></> : ''}
                </div>
                {props.People ?
                  <>
                    <div className="user-profile mobile d-flex d-lg-none align-items-center">
                      <span className="profile-img"><img loading="lazy" className="banner-img" src={getSrc(props.People.Tile_Image)} alt={`${props.People.Name} - Martyn Gerrard`} /></span>
                      <div className="profile-info">
                        <strong className="d-block">{props.People.Name}</strong>
                        <span className="d-block">{props.People.Designation}</span>
                      </div>
                    </div></> : ''}
              </Col>
            }
          </Row>
        </Container>
        <DownloadPDF openForm={openDownloadForm} setOpenForm={setOpenDownloadForm} fileName={props.CTA_Link} />
      </section>
    </>
  )
}


export default TeamBlock
